// Query params that identify a participant. Every in-app link must carry them,
// otherwise later pages (e.g. /thanks) can no longer tell who the participant is.
const TRACKING_PARAMS = [
  "user", "user_id", "task_id", "job_id", // Clickworker
  "PROLIFIC_PID", "STUDY_ID", "SESSION_ID", // Prolific
  "email",
];

export function withTrackingParams(path, search = window.location.search) {
  const current = new URLSearchParams(search);
  const kept = new URLSearchParams();
  TRACKING_PARAMS.forEach((key) => {
    const value = current.get(key);
    if (value) kept.set(key, value);
  });
  const queryString = kept.toString();
  return queryString ? `${path}?${queryString}` : path;
}

// Clickworker participants (identified by user_id) consent on /start; everyone else on /consent.
export function consentPath(search = window.location.search) {
  const isClickworker = new URLSearchParams(search).get("user_id");
  return withTrackingParams(isClickworker ? "/start" : "/consent", search);
}
